<template>
  <div
      class="flex justify-between mt-4">
    <div
      v-for="(item, index) in processBarItems"
      v-bind:key="index"
      :class="['flex flex-col items-center w-full mt-2', index%2==0?'':'justify-center']"
    >
      <div
        v-if="index % 2 == 0"
        class="items-center content-center flex flex-col"
      >
        <div
          :class="[
            'rounded-full h-8 w-8 flex items-center justify-center border',
            processBarCurrentItem > index + 1
              ? theme.processBar.itemDoneBackgroundColor
              : processBarCurrentItem === index + 1
              ? theme.processBar.currentItemBackgroundColor
              : theme.processBar.futureItemBackgroundColor,
          ]"
        >
          <div
            :class="[
              processBarCurrentItem >= index ? 'text-white' : theme.processBar.futureItemTextColor,
            ]"
          >
            {{ item.number }}
          </div>
        </div>
        <div class="flex flex-row justify-around text-center mt-2">
          <p
            :class="[
              'text-xs w-14 break-words',
              processBarCurrentItem > index + 1
                ? theme.processBar.itemDoneTextColor
                : processBarCurrentItem === index + 1
                ? theme.processBar.currentItemTextColor
                : theme.processBar.futureItemBottomTextColor,
            ]"
          >
            {{ lang[item.text][language] }}
          </p>
        </div>
      </div>
      <div
        v-else
        :class="[
          'border-t-2 w-full',
          processBarCurrentItem > index + 1
            ? theme.processBar.itemDoneTextColor
            : processBarCurrentItem === index + 1
            ? 'border-blue-800'
            : 'border-gray-500',
        ]"
      >
        <!--Border between the processbarItems -->
        <div>
          <p class="text-white md:text-gray-300"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lang from "../lang";
export default {
  computed: {
    ...mapGetters(["menu", "theme", "tableId", "language"]),
    ...mapGetters("Cart", [
      "tableId",
    ]),
    processBarCurrentItem: {
      get() {
        if (this.$route.name == "payment") {
          this.$store.commit("updateProcessBarCurrentItem", 7);
        }
        return this.$store.getters["processBarCurrentItem"];
      },
    },
  },
  data() {
    return {
      lang: lang,
      processBarItems: [],
    };
  },
  mounted() {
    let number = 1;

    //Altijd TONEN
    this.processBarItems = [{ text: "select_items", number: number++, id: 1 }];

    if (
      this.menu.pos_mode == "take-out" &&
      (this.menu.timeslots_mode == "general" ||
        this.menu.timeslots_mode == "individual")
    ) {
      this.processBarItems.push({ text: "" });
      this.processBarItems.push({
        text: "Time",
        number: number++,
        id: 2,
      });
    } else {
      if(this.tableId ===0)
      {
        this.processBarItems.push({ text: "" });
        this.processBarItems.push({
          text: "table",
          number: number++,
          id: 3,
        });
      }
    }
    if (!this.menu.customer_details_disabled || this.menu.pos_mode =="take-out") {
      this.processBarItems.push({ text: "" });
      this.processBarItems.push({
        text: "contact_details",
        number: number++,
        id: 4,
      });
    }

    //Altijd TONEN
    this.processBarItems.push({ text: "" });
    this.processBarItems.push({
      text: "payment",
      number: number++,
      id: 4,
    });
  },
};
</script>